











































































import Base from "@/views/Base";
import {Component, Prop} from "vue-property-decorator";
import {ElementListItem} from "@/models/Presentation";
import ElementThumbnail from '@/views/presentation/components/ElementThumbnail.vue';

@Component({
  components: { ElementThumbnail }
})
export default class PresentationElementRow extends Base {
  @Prop({required: true}) item!: ElementListItem;
  @Prop({type: Boolean, default: false}) showNotes!: boolean;
  @Prop() selectedElement!: ElementListItem | null;

  nameEdit = false;
  preventBlur = false;
  oldTitle = '';

  editName(): void {
    this.nameEdit = true;
    this.oldTitle = this.item.name;
    this.$nextTick(() => (this.$refs['name-input'] as HTMLInputElement).focus());
  }

  get elementType(): string {
    if(this.item.type == 'WEBVIDEO'){
      return this.t('presentation.document.' + this.item.entity.videoSource);
    }
    return this.t('presentation.document.' + this.item.type);
  }

  handleBlur(): void {
    if (!this.preventBlur) {
      this.updateName();
    }
    this.preventBlur = false;
  }

  handleKeydown(): void {
    this.preventBlur = true;
    this.updateName();
  }

  handleEsc(): void {
    this.preventBlur = true;
    this.item.name = this.oldTitle;
    this.nameEdit = false;
  }

  updateName(): void {
    this.nameEdit = false;
    this.$emit('update-name');
  }

  escapeHtml(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.innerText;
  }

  get isSelected(): boolean {
    return this.item.id === this.selectedElement?.id;
  }
}
